/**
 * The picture that follows the cursor during a drag.
 *
 * Left alone, the browser snapshots the whole dragged row — full list width,
 * title and snippet. A small chip carrying just the title reads better and
 * keeps the drop target visible underneath it.
 */

/** Where the cursor sits within the chip, so it hangs off the pointer. */
export const CHIP_OFFSET = { x: 14, y: 12 }

export function makeDragImage(title: string, count: number): HTMLElement {
  const chip = document.createElement('div')
  chip.className = 'drag-chip'

  const label = document.createElement('span')
  label.className = 'drag-chip-title'
  label.textContent = title.trim() || 'New Note'
  chip.append(label)

  if (count > 1) {
    const badge = document.createElement('span')
    badge.className = 'drag-chip-count'
    badge.textContent = String(count)
    chip.append(badge)
  }
  return chip
}

/**
 * Builds the chip, hands it to the drag, and cleans it up.
 *
 * The element has to be in the document and laid out when setDragImage runs —
 * the browser snapshots it there and then — so it is attached first and
 * removed on the next tick, once the snapshot has been taken.
 */
export function attachDragImage(dt: DataTransfer, title: string, count: number): void {
  if (typeof dt.setDragImage !== 'function') return
  const chip = makeDragImage(title, count)
  document.body.append(chip)
  dt.setDragImage(chip, CHIP_OFFSET.x, CHIP_OFFSET.y)
  setTimeout(() => chip.remove(), 0)
}
